export const AWS_SUPPORT_RESOLVED_OPENED = 'opened';
export const AWS_SUPPORT_RESOLVED_CLOSED = 'closed';
export const AWS_SUPPORT_RESOLVED = [AWS_SUPPORT_RESOLVED_OPENED, AWS_SUPPORT_RESOLVED_CLOSED];

const AWSSUPPORT_SECTION_FORM = 'form';
const AWSSUPPORT_SECTION_LIST = 'list';
const AWSSUPPORT_SECTION_COMMENTS = 'comments';

export const AWSSUPPORT_SECTIONS = {
    AWSSUPPORT_SECTION_FORM,
    AWSSUPPORT_SECTION_LIST,
    AWSSUPPORT_SECTION_COMMENTS
};

const AWSSUPPORT_TYPE_BILLING = 'billing';
const AWSSUPPORT_TYPE_TECHNICAL = 'technical';

export const AWSSUPPORT_TYPES_ARR = [
    AWSSUPPORT_TYPE_BILLING,
    AWSSUPPORT_TYPE_TECHNICAL
];
export const AWSSUPPORT_TYPES = {
    AWSSUPPORT_TYPE_BILLING,
    AWSSUPPORT_TYPE_TECHNICAL
};

const
    STATUS_AWS_SUPPORT_UNASSIGNED = 'unassigned',
    STATUS_AWS_SUPPORT_OPENED = 'opened',
    STATUS_AWS_SUPPORT_REOPENED = 'reopened',
    STATUS_AWS_SUPPORT_WORK_IN_PROGRESS = 'work-in-progress',
    STATUS_AWS_SUPPORT_PENDING_CUSTOMER_ACTION = 'pending-customer-action',
    STATUS_AWS_SUPPORT_CUSTOMER_ACTION_COMPLETE = 'customer-action-completed',
    STATUS_AWS_SUPPORT_RESOLVED = 'resolved';

export const STATUS_AWS_SUPPORT = {
    STATUS_AWS_SUPPORT_UNASSIGNED,
    STATUS_AWS_SUPPORT_OPENED,
    STATUS_AWS_SUPPORT_REOPENED,
    STATUS_AWS_SUPPORT_WORK_IN_PROGRESS,
    STATUS_AWS_SUPPORT_PENDING_CUSTOMER_ACTION,
    STATUS_AWS_SUPPORT_CUSTOMER_ACTION_COMPLETE,
    STATUS_AWS_SUPPORT_RESOLVED
};

const
    SEVERITY_AWS_SUPPORT_LOW = 'low',
    SEVERITY_AWS_SUPPORT_NORMAL = 'normal',
    SEVERITY_AWS_SUPPORT_HIGH = 'high',
    SEVERITY_AWS_SUPPORT_URGENT = 'urgent';

export const SEVERITY_AWS_SUPPORT = {
    SEVERITY_AWS_SUPPORT_LOW,
    SEVERITY_AWS_SUPPORT_NORMAL,
    SEVERITY_AWS_SUPPORT_HIGH,
    SEVERITY_AWS_SUPPORT_URGENT
};

export const AWS_SUPPORT_MAX_FILES = 3;
export const AWS_SUPPORT_MAX_SIZE = 5;



// WEBPACK FOOTER //
// ./src/config/constants/awsSupport.js